import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DetailsPage from '../components/DetailsPage';

function WaterTankDetails() {
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { serviceId, serviceName } = useParams();
  const [totalAmount, setTotalAmount] = useState('0.00');

  const formData = new FormData();
  formData.append('service_id', serviceId);

  useEffect(() => {
    const fetchWaterTankData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service_reports`,{
          method: 'POST',
          body: formData
        });
        const data = await response.json();
        setApiData(data.report_list || []);
        setTotalAmount(data?.total_amount || '0.00');
      } catch (error) {
        console.error('Error fetching water tank data:', error);
        setApiData([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchWaterTankData();
  }, [serviceId]);

  const columns = [
    { field: 'booking_id', header: 'Booking ID' },
    { field: 'service_date', header: 'Service Date' },
    { field: 'booked_on', header: 'Booked On' },
    { field: 'customer_name', header: 'Customer Name' },
    { field: 'address', header: 'Address' },
    { field: 'amount', header: 'Amount' }
  ];

  const handleRowClick = (row) => {
    console.log('Row clicked:', row);
  };

  const handleDateFilterChange = (startDate, endDate, filteredData) => {
    // Calculate total amount for filtered data
    const total = filteredData.reduce((sum, item) => {
      const amount = parseFloat(item.amount) || 0;
      return sum + amount;
    }, 0);
    setTotalAmount(total.toFixed(2));
  };

  return (
    <DetailsPage
      title={`${serviceName} Bookings`}
      backPath="/water-tank"
      columns={columns}
      data={apiData}
      onRowClick={handleRowClick}
      isLoading={isLoading}
      dateField="booked_on"
      totalAmount={totalAmount}
      showTotalAmount={true}
      onDateFilterChange={handleDateFilterChange}
    />
  );
}

export default WaterTankDetails; 